import styled from '@emotion/styled';
import { Y400, N700 } from '../../../components/Colors';

export const Content = styled.div`
    .margin-auto {
        margin: auto;
    }

    .btn-kembali {
        background-color: ${Y400};
        border-color: ${Y400};
        color: ${N700};
        box-shadow: 1px 3px 5px #888888;
        margin-bottom: 2%;
    }

    .btn-primary {
        margin-top : 20px;
    }

    .detail-atribut {
        border-bottom: 1px solid #E0E0E0;
        display: inline-flex;
        width: 100%;
        margin-top: 2%;
    }

    .link-proposal {
        color: #B6B600;
    }

    h4 {
        margin-bottom: 15px;
    }

    .btnAction {
        padding: 10px 20px;
        margin-left: 2%;
    }

    .capitalize {
        text-transform: capitalize
    }

    .btnDetail {
        margin-top: 0;
    }

    #statusButton {
        position: relative;
        right: 0px;
    }

    .row-button {
        text-align: right;
        max-width: 883px;
        margin: auto;
    }
`;
